module.exports = __webpack_public_path__ + "media/images/tak_mil_splash_bg_no_str_lines-95fb130aa3394fdc33b4d3c65b7510d3.jpg";